import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useAxios
 from '../../axios/useAxios';
import { ACCOUNT, BRAND } from '../../constants/routes';
import PageLoader from '../../components/loader/PageLoader';
import BrandConversionLabel from './BrandConversionLabel';
import ScanFooter from '../account/ScanFooter';
import BackButton from '../../components/button/BackButton';
import { isAppPWA } from '../../utils/helper-functions';
import { FooterAccount } from '../../components/footerAccount';

const BrandDetailScreen = () => {
  const { brandId } = useParams();
  const axiosInstance = useAxios();
  const navigate = useNavigate();
  const location = useLocation();

  const [brand, setBrand] = useState(undefined);

  const prevPage = location.state?.prevPage;

  useEffect(() => {
    axiosInstance.get(`/brands/${brandId}`).then((response) => {
      setBrand(response.data);
    });
  }, []);

  const pikkoBrandOfferText = (
    currentBrand,
  ) => `Pour chaque euro dépensé dans les produits de la gamme ${currentBrand.name},
  récupère ${currentBrand.fidelityConversionRate} points Pikoins.`;

  const onBack = () => {
    if (prevPage) {
      navigate(prevPage);
    } else {
      console.info('BrandDetailScreen redirecting to ACCOUNT', brand);
      navigate(ACCOUNT);
    }
  };
  const isPWA = isAppPWA();
  const [selectedItem, setSelectedItem] = useState(1);

  return (
    <div id="brand-detail-screen" className={isPWA ? 'pwa' : ''}>
      <FooterAccount
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
      <div className="brand-detail-screen-body">
        {brand ? (
          <div className="brand-content">
            {!isPWA && <BackButton onClick={onBack} />}
            <div className="brand-logo-container full-width">
              <img
                className="brand-logo-img"
                src={brand.logoUrl}
                alt={brand.name}
                style={{ background: brand.color }}
              />
            </div>
            <div className="pikko-brand-offer">
              <div className="pikko-brand-offer-title">
                <div className="brand-label">Offre PikkoPay</div>
                <BrandConversionLabel brand={brand} fixed />
              </div>
              <div className="brand-text">{pikkoBrandOfferText(brand)}</div>
            </div>
            <div>
              <div className="brand-label brand-name">{brand.name}</div>
              <div className="brand-text">{brand.brandDescription}</div>
            </div>
          </div>
        ) : (
          <PageLoader />
        )}
      </div>
      <ScanFooter originPath={`${BRAND}/${brandId}`} />
    </div>
  );
};

export default BrandDetailScreen;
